import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Gallery from "../shared/about/Gallery"
import HeadingM from "../shared/HeadingM"

const query = graphql`
  {
    allContentfulAsset(
      filter: {
        metadata: {
          tags: { elemMatch: { contentful_id: { eq: "onePhoto" } } }
        }
      }
    ) {
      edges {
        node {
          gatsbyImageData
        }
      }
    }
  }
`

const AboutGallery = () => {
  const data = useStaticQuery(query)
  const items = data.allContentfulAsset.edges.map(item => {
    const { gatsbyImageData } = item.node
    return {
      src: gatsbyImageData.images.fallback.src,
      height: gatsbyImageData.height,
      width: gatsbyImageData.width,
    }
  })
  return (
    <div className="mt-28">
      <HeadingM title="ギャラリー" target="one" />
      <Gallery items={items} />
    </div>
  )
}

export default AboutGallery
